.hero {
  padding-block: var(--sp-12) var(--sp-16);
  background: linear-gradient(180deg, var(--surface-alt) 0%, var(--surface) 100%);
  border-bottom: 1px solid var(--border);
}
.inner {
  display: grid;
  gap: var(--sp-8);
  align-items: center;
}
.text {
  display: grid;
  gap: var(--sp-4);
  max-width: 40rem;
}
.lead {
  margin: 0;
  font-size: var(--fs-lg);
}
.image {
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-lg);
}
@media (min-width: 64rem) {
  .withImage {
    grid-template-columns: 1.1fr 1fr;
  }
}
@media (max-width: 47.99rem) {
  .hero {
    padding-block: var(--sp-8) var(--sp-10);
  }
}
